// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const COVID19_WARNING__NAME = "Koronav\u00edrus";
export const COVID19_WARNING__STAYHOME = "Zosta\u0148te doma, spomal\u00edte epid\u00e9miu!";
export const COVID19_WARNING__WIKILINK = "/zdravie/koronavirus-je-tu-zostante-doma-spomalite-epidemiu/";
export const FORUM_READ_MORE = "\u010c\u00edtaj viac...";
